export const COLOR_PRIMARY = '#084272';
export const COLOR_ADDITIONAL = '#0C4A69';
export const COLOR_BACKGROUND_DARK = '#08315c';
export const COLOR_LIGHT = '#def5ff';

export const COLOR_ERROR = '#E05252';
export const COLOR_SUCCESS = '#1FAD66';
